import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label, Input, FormFeedback } from 'reactstrap';

import api from "../../../api";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.saldos.categorias.delete}
                postUrl={api.saldos.categorias.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Categoria ha sido eliminada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Categoria"}
                buttonTitle={"Eliminar Categoria"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                className={"ui-modal-dialog ui-modal-md"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la categoria</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input disabled={true} type="text" name="nombre"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Saldos/Categorias/Delete.js